
//Environment menus
export const menus_env=[
  {
    mCode:"world_political_map",
    title:"World political map",
    icon:"icon-huaban-"
  },
  {
    mCode:"global_satellite_image",
    title:"Global satellite image",
    icon:"icon-quanqiu"
  },
  {
    mCode:"global_elevation",
    title:"Global elevation",
    icon:"icon-quanqiu"
  },
  // {
  //   mCode:"global_terrain_slope",
  //   title:"Global terrain slope",
  //   icon:"icon-turang"
  // },
  {
    mCode:"global_climate_zones",
    title:"Global climate zones",
    icon:"icon-qihoubianhua"
  },
  // {
  //   mCode:"global_river_system",
  //   title:"Global river system",
  //   icon:"icon-jurassic_heliuxiangdai"
  // },
  {
    mCode:"global_soil",
    title:"Global soil",
    icon:"icon-quanqiuhuadaiquan"
  }
];

//Risk Change menus
export const menus_risk=[
  {
    mCode:"risk_landcover",
    title:"risk Land Cover",
    icon:"icon-quanqiu"
  },
  {
    mCode:"exposure_soil",
    title:"risk Soil",
    icon:"icon-turang"
  },
  {
    mCode:"exposure_climate",
    title:"risk Climate Zones",
    icon:"icon-qihoubianhua"
  },
  {
    mCode:"env_river",
    title:"risk River System",
    icon:"icon-jurassic_heliuxiangdai"
  },
  {
    mCode:"env_terrain",
    title:"risk Terrain Slope",
    icon:"icon-quanqiuhuadaiquan"
  },
  {
    mCode:"env_digitalElevationModels",
    title:"risk Digital Elevation Models",
    icon:"icon-guojiaguanliicon-"
  },
  {
    mCode:"env_politicalMaps",
    title:"risk Political Maps",
    icon:"icon-huaban-"
  }
];


export const radioGroupData = {
  cc_wind:{
    cim:[
      {radio_title:"Annual", radio_code:"ann"},
      {radio_title:"Winter(DJF)", radio_code:"djf"},
      {radio_title:"Summer(JJA)", radio_code:"jja"},
    ]
  }
}

export const radioGroupData_V2 = {

  //降雨
  cc_prcptot_mean:[
    {radio_title:"Annual", radio_code:"ann"},
    {radio_title:"Winter(DJF)", radio_code:"djf"},
    {radio_title:"Summer(JJA)", radio_code:"jja"},
  ],
  cc_prcptot_var:[
    {radio_title:"Interannual", radio_code:"ann"},
    {radio_title:"Winter(DJF)", radio_code:"djf"},
    {radio_title:"Summer(JJA)", radio_code:"jja"},
  ],
  cc_prcptot_ext:[
    {radio_title:"R10MM", radio_code:"r10mm"},
    {radio_title:"RX1D", radio_code:"rx1day"},
    {radio_title:"Rx5D", radio_code:"rx5day"},
  ],

  //温度
  cc_tmean_mean:[
    {radio_title:"Annual Mean", radio_code:"ann"},
    {radio_title:"Winter(DJF)", radio_code:"djf"},
    {radio_title:"Summer(JJA)", radio_code:"jja"},
  ],
  cc_tstd_var:[
    {radio_title:"Interannual", radio_code:"ann"},
    {radio_title:"Winter(DJF)", radio_code:"djf"},
    {radio_title:"Summer(JJA)", radio_code:"jja"},
  ],
  cc_txx_ext:[
    {radio_title:"TXx", radio_code:"txx"},
    {radio_title:"TN10p", radio_code:"tn10p"},
    {radio_title:"TX90p", radio_code:"tx90p"},
  ],

  //降雨
  cc_sfcwind_mean:[
    {radio_title:"Annual", radio_code:"ann"},
    {radio_title:"Winter(DJF)", radio_code:"djf"},
    {radio_title:"Summer(JJA)", radio_code:"jja"},
  ],
  cc_sfcwind_var:[
    {radio_title:"Interannual", radio_code:"ann"},
    {radio_title:"Winter(DJF)", radio_code:"djf"},
    {radio_title:"Summer(JJA)", radio_code:"jja"},
  ],
  cc_sfcwindmax_ext:[
    {radio_title:"W95p", radio_code:"ann"},
  ],


}



export const cascaderData = {

  cc_prcptor:[
    {
      value: '2000_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6'},
        {value: '2030s_rcp45', label: 'RCP4.5'},
        {value: '2030s_rcp85', label: 'RCP8.5'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6'},
        {value: '2050s_rcp45', label: 'RCP4.5'},
        {value: '2050s_rcp85', label: 'RCP8.5'},
      ]
    },
  ],
  cc_temprature:[
  {
    value: '2000s_s0',
    label: 'Baseline',
  },
  {
    value: '2030S',
    label: '2030S',
    children:[
      {value: '2030s_rcp26', label: 'RCP2.6'},
      {value: '2030s_rcp45', label: 'RCP4.5'},
      {value: '2030s_rcp85', label: 'RCP8.5'},
    ]
  },
  {
    value: '2050S',
    label: '2050S',
    children:[
      {value: '2050s_rcp26', label: 'RCP2.6'},
      {value: '2050s_rcp45', label: 'RCP4.5'},
      {value: '2050s_rcp85', label: 'RCP8.5'},
    ]
  },
],
  cc_wind:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6'},
        {value: '2030s_rcp45', label: 'RCP4.5'},
        {value: '2030s_rcp85', label: 'RCP8.5'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6'},
        {value: '2050s_rcp45', label: 'RCP4.5'},
        {value: '2050s_rcp85', label: 'RCP8.5'},
      ]
    }]
}



/***********************************************************************************************************************
 * Population and Economic System Changes
 * **/


//Population and economic system changes
export const menus_exposure=[
  {
    mCode:"Population",
    title:"Population",
    icon:"icon-quanqiu"
  },
  {
    mCode:"Gross_domestic_production",
    title:"Gross domestic production",
    icon:"icon-turang"
  },
  {
    mCode:"Global_crop_distribution",
    title:"Global crop distribution",
    icon:"icon-qihoubianhua"
  },
  {
    mCode:"Global_industrial_value_added",
    title:"Global industrial value added",
    icon:"icon-jurassic_heliuxiangdai"
  },
  {
    mCode:"Global_road_system",
    title:"Global road system",
    icon:"icon-quanqiuhuadaiquan"
  },
  {
    mCode:"Global_population_exposure_to_high_temperature",
    title:"Global population exposure to high temperature",
    icon:"icon-guojiaguanliicon-"
  },
  {
    mCode:"Global_population_exposure_to_rainstorm",
    title:"Global population exposure to rainstorm",
    icon:"icon-huaban-"
  },
  {
    mCode:"global_gdp_exposure_to_drought",
    title:"Global GDP exposure to drought",
    icon:"icon"
  },
  // {
  //   mCode:"Global_GDP_exposure_to_flood",
  //   title:"Global GDP exposure to flood",
  //   icon:"icon-huaban-"
  // },
  {
    mCode:"Global_Crop_exposure_to_extremely_hightemperature",
    title:"Global crop exposure to extremely high temperature",
    icon:"icon-huaban-"
  }
];



export const Pesc_radioGroupData = {

  Population:[],
  Gross_domestic_production:[],
  Global_crop_distribution:[
    {radio_title:"Rice", radio_code:"rice"},
    {radio_title:"Wheat", radio_code:"wheat"},
    {radio_title:"Maize", radio_code:"maize"}
  ],
  Global_industrial_value_added:[],
  Global_road_system:[],
  Global_population_exposure_to_high_temperature:[],
  Global_population_exposure_to_rainstorm:[],
  Global_GDP_exposure_to_flood:[],
  Global_Crop_exposure_to_extremely_hightemperature:[
    {radio_title:"Rice", radio_code:"rice"},
    {radio_title:"Wheat", radio_code:"wheat"},
    {radio_title:"Maize", radio_code:"maize"},
  ],
  //新添加要素
  global_gdp_exposure_to_drought:[
    {radio_title:"Normal", radio_code:"normal"},
    {radio_title:"Mild", radio_code:"mild"},
    {radio_title:"Moderate", radio_code:"moderate"},
    {radio_title:"Severe", radio_code:"severe"},
    {radio_title:"Extreme", radio_code:"extreme"}
  ]
}

export const Pesc_cascaderData = {
  Population:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_ssp1', label: 'SSP1'},
        {value: '2030s_ssp2', label: 'SSP2'},
        {value: '2030s_ssp3', label: 'SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_ssp1', label: 'SSP1'},
        {value: '2050s_ssp2', label: 'SSP2'},
        {value: '2050s_ssp3', label: 'SSP3'},
      ]
    },
  ],
  Gross_domestic_production:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_ssp1', label: 'SSP1'},
        {value: '2030s_ssp2', label: 'SSP2'},
        {value: '2030s_ssp3', label: 'SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_ssp1', label: 'SSP1'},
        {value: '2050s_ssp2', label: 'SSP2'},
        {value: '2050s_ssp3', label: 'SSP3'},
      ]
    },
  ],
  Global_crop_distribution:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6'},
        {value: '2030s_rcp45', label: 'RCP4.5'},
        {value: '2030s_rcp85', label: 'RCP8.5'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6'},
        {value: '2050s_rcp45', label: 'RCP4.5'},
        {value: '2050s_rcp85', label: 'RCP8.5'},
      ]
    },
  ],
  Global_industrial_value_added:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_ssp1', label: 'SSP1'},
        {value: '2030s_ssp2', label: 'SSP2'},
        {value: '2030s_ssp3', label: 'SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_ssp1', label: 'SSP1'},
        {value: '2050s_ssp2', label: 'SSP2'},
        {value: '2050s_ssp3', label: 'SSP3'},
      ]
    },
  ],
  Global_road_system:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_ssp1', label: 'SSP1'},
        {value: '2030s_ssp2', label: 'SSP2'},
        {value: '2030s_ssp3', label: 'SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_ssp1', label: 'SSP1'},
        {value: '2050s_ssp2', label: 'SSP2'},
        {value: '2050s_ssp3', label: 'SSP3'},
      ]
    },
  ],
  Global_population_exposure_to_high_temperature  :[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2030s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2030s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2050s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2050s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
  ],
  Global_population_exposure_to_rainstorm:[
    {
    value: '2000s_s0',
    label: 'Baseline',
  },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2030s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2030s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2050s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2050s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    }],
  Global_GDP_exposure_to_flood:[ {
    value: '2000s_s0',
    label: 'Baseline',
  },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2030s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2030s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2050s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2050s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    }],
  Global_Crop_exposure_to_extremely_hightemperature:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6'},
        {value: '2030s_rcp45', label: 'RCP4.5'},
        {value: '2030s_rcp85', label: 'RCP8.5'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6'},
        {value: '2050s_rcp45', label: 'RCP4.5'},
        {value: '2050s_rcp85', label: 'RCP8.5'},
      ]
    },
  ],

  /**
   *  干旱暴露
   * */
  // global_gdp_exposure_to_drought:[
  //   {
  //     value: 'his_2000s',
  //     label: 'Baseline',
  //   },
  //   {
  //     value: '2030S',
  //     label: '2030S',
  //     children:[
  //       {
  //         value: 'SSP1',
  //         label: 'SSP1',
  //         children:[
  //           {value: 'rcp26_ssp1_2030s', label: 'RCP2.6'},
  //           {value: 'rcp45_ssp1_2030s', label: 'RCP4.5'},
  //           {value: 'rcp85_ssp1_2030s', label: 'RCP8.5'},
  //         ]
  //       },
  //       {
  //         value: 'SSP2',
  //         label: 'SSP2',
  //         children:[
  //           {value: 'rcp26_ssp2_2030s', label: 'RCP2.6'},
  //           {value: 'rcp45_ssp2_2030s', label: 'RCP4.5'},
  //           {value: 'rcp85_ssp2_2030s', label: 'RCP8.5'},
  //         ]
  //       },
  //       {
  //         value: 'SSP3',
  //         label: 'SSP3',
  //         children:[
  //           {value: 'rcp26_ssp3_2030s', label: 'RCP2.6'},
  //           {value: 'rcp45_ssp3_2030s', label: 'RCP4.5'},
  //           {value: 'rcp85_ssp3_2030s', label: 'RCP8.5'},
  //         ]
  //       },
  //     ]
  //   },
  //   {
  //     value: '2050S',
  //     label: '2050S',
  //     children:[
  //       {
  //         value: 'SSP1',
  //         label: 'SSP1',
  //         children:[
  //           {value: 'rcp26_ssp1_2050s', label: 'RCP2.6'},
  //           {value: 'rcp45_ssp1_2050s', label: 'RCP4.5'},
  //           {value: 'rcp85_ssp1_2050s', label: 'RCP8.5'},
  //         ]
  //       },
  //       {
  //         value: 'SSP2',
  //         label: 'SSP2',
  //         children:[
  //           {value: 'rcp26_ssp2_2050s', label: 'RCP2.6'},
  //           {value: 'rcp45_ssp2_2050s', label: 'RCP4.5'},
  //           {value: 'rcp85_ssp2_2050s', label: 'RCP8.5'},
  //         ]
  //       },
  //       {
  //         value: 'SSP3',
  //         label: 'SSP3',
  //         children:[
  //           {value: 'rcp26_ssp3_2050s', label: 'RCP2.6'},
  //           {value: 'rcp45_ssp3_2050s', label: 'RCP4.5'},
  //           {value: 'rcp85_ssp3_2050s', label: 'RCP8.5'},
  //         ]
  //       },
  //     ]
  //   },
  // ]


  global_gdp_exposure_to_drought:[
    {
      value: 'his_2000s',
      label: 'Baseline',
    }, {
      value: '2030S',
      label: '2030S',
      children:[
        {value: 'rcp26_ssp1_2030s', label: 'RCP2.6-SSP1'},
        {value: 'rcp45_ssp2_2030s', label: 'RCP4.5-SSP2'},
        {value: 'rcp85_ssp3_2030s', label: 'RCP8.5-SSP3'},
      ]
    }, {
      value: '2050S',
      label: '2050S',
      children:[
        {value: 'rcp26_ssp1_2050s', label: 'RCP2.6-SSP1'},
        {value: 'rcp45_ssp2_2050s', label: 'RCP4.5-SSP2'},
        {value: 'rcp85_ssp3_2050s', label: 'RCP8.5-SSP3'},
      ]
    }
  ]

}







/***********************************************************************************************************************
 * Cloable Change Risk Configs
 * **/
export const Risk_radioGroupData = {

  Heatwave:[],
  Flood:[],

  Rice:[
    {radio_title:"yield mean", radio_code:"mean"},
    {radio_title:"yield variability", radio_code:"var"},
    {radio_title:"yield extreme", radio_code:"ext"},
  ],
  Wheat:[
    {radio_title:"yield mean", radio_code:"mean"},
    {radio_title:"yield variability", radio_code:"var"},
    {radio_title:"yield extreme", radio_code:"ext"},
  ],
  Maize:[
    {radio_title:"yield mean", radio_code:"mean"},
    {radio_title:"yield variability", radio_code:"var"},
    {radio_title:"yield extreme", radio_code:"ext"},
  ],
  GDPLossRisksFlood:[
    {radio_title:"Global GDP loss", radio_code:"txx"},
    {radio_title:"Hotspots GDP loss", radio_code:"tn10p"},
    {radio_title:"TX90p", radio_code:"tx90p"},
  ],
}

export const Risk_cascaderData = {
  Heatwave:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2030s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2030s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6-SSP1'},
        {value: '2050s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2050s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
  ],
  Flood:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2030s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2050s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
  ],
  Rice:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6'},
        {value: '2030s_rcp45', label: 'RCP4.5'},
        {value: '2030s_rcp85', label: 'RCP8.5'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6'},
        {value: '2050s_rcp45', label: 'RCP4.5'},
        {value: '2050s_rcp85', label: 'RCP8.5'},
      ]
    },
  ],
  Wheat:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6'},
        {value: '2030s_rcp45', label: 'RCP4.5'},
        {value: '2030s_rcp85', label: 'RCP8.5'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6'},
        {value: '2050s_rcp45', label: 'RCP4.5'},
        {value: '2050s_rcp85', label: 'RCP8.5'},
      ]
    },
  ],
  Maize:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp26', label: 'RCP2.6'},
        {value: '2030s_rcp45', label: 'RCP4.5'},
        {value: '2030s_rcp85', label: 'RCP8.5'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp26', label: 'RCP2.6'},
        {value: '2050s_rcp45', label: 'RCP4.5'},
        {value: '2050s_rcp85', label: 'RCP8.5'},
      ]
    },
  ],
  GDPLossRisksFlood:[
    {
      value: '2000s_s0',
      label: 'Baseline',
    },
    {
      value: '2030S',
      label: '2030S',
      children:[
        {value: '2030s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2030s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
    {
      value: '2050S',
      label: '2050S',
      children:[
        {value: '2050s_rcp45', label: 'RCP4.5-SSP2'},
        {value: '2050s_rcp85', label: 'RCP8.5-SSP3'},
      ]
    },
  ]
}




// WEBPACK FOOTER //
// ./src/view/BSD/BSDConfig.js